export default "__VITE_PUBLIC_ASSET__bfb8a930__"